import { render, staticRenderFns } from "./errorPage.vue?vue&type=template&id=583074b8&scoped=true"
import script from "./errorPage.vue?vue&type=script&lang=js"
export * from "./errorPage.vue?vue&type=script&lang=js"
import style0 from "./errorPage.vue?vue&type=style&index=0&id=583074b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583074b8",
  null
  
)

export default component.exports